'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaOpencart = function FaOpencart(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.7 31.6q0 1.2-0.9 2.1t-2 0.8-2-0.8-0.9-2.1 0.9-2 2-0.8 2 0.8 0.9 2z m-13.1 0q0 1.2-0.9 2.1t-2 0.8-2.1-0.8-0.8-2.1 0.8-2 2.1-0.8 2 0.8 0.9 2z m-13.6-26.1q1 1 1.9 1.8t2.2 1.5 2.3 1.1 2.9 0.8 3.5 0.5 4.4 0.3 5.3 0.2 6.6 0q2.4 0 4.2 0.1t3.2 0.3 2.2 0.5 1.2 0.7 0.4 0.9-0.3 1.1-1 1.3-1.6 1.6-2 1.9-2.4 2.1q-3.3 2.7-5 4.3 0.5-0.9 1.3-1.9t1.7-1.9 1.6-1.7 1.5-1.6 0.9-1.4 0.2-1.2-0.8-1-2-0.7-3.6-0.4-5.3-0.1q-2.9 0-5.5-0.1t-4.5-0.4-3.5-0.8-2.8-0.9-2.2-1-1.6-1.2-1.2-1.3-0.9-1.2-0.7-1.2-0.6-1z' })
        )
    );
};

exports.default = FaOpencart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/opencart.js
// module id = 1427
// module chunks = 0